import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppState } from '../../models/state';
import { GoogleMapService } from '../../services/google-map.service';
import { StateService } from '../../services/state.service';

@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss']
})
export class GoogleMapComponent implements AfterViewInit, OnDestroy {

  @ViewChild('map', { static: false }) mapElement: ElementRef;

  @Input() set bounds(v: google.maps.LatLngBounds) {
    if (v) this.map?.fitBounds(v);
  }

  map: google.maps.Map;
  center: google.maps.LatLng;
  mapOptions: google.maps.MapOptions;
  zoom: number;

  constructor(
    public googleMapService: GoogleMapService
  ) {
    this.zoom = 6;
    this.center = this.googleMapService.getSpainCoordinates();
    this.mapOptions = {
      center: this.center,
      styles: [{
        stylers: [{
          saturation: -100
        }]
      }],
      zoom: this.zoom,
    };
  }

  ngOnDestroy(): void {
    this.googleMapService.mapDestroy();
  }

  ngAfterViewInit(): void {
    this.mapInit();
  }

  mapInit(): void {
    this.map = new google.maps.Map(this.mapElement.nativeElement, this.mapOptions);
    this.googleMapService.map = this.map;
    this.map.addListener('idle', () => {
      this.googleMapService.mapLoaded();
    });
  }
}
